/** Altura recomendada para playlists: más espacio para la lista de canciones. */
export const SPOTIFY_PLAYLIST_EMBED_HEIGHT = 560;

type SpotifyKind = "playlist" | "album" | "track" | "artist";

const SPOTIFY_URL_RE = /open\.spotify\.com\/(?:intl-[a-z]{2}\/)?(playlist|album|track|artist)\/([a-zA-Z0-9]+)/i;
const SPOTIFY_URI_RE = /^spotify:(playlist|album|track|artist):([a-zA-Z0-9]+)$/i;

const parseSpotifyResource = (value: string) => {
  const raw = value.trim();
  if (!raw) return null;

  const uriMatch = raw.match(SPOTIFY_URI_RE);
  if (uriMatch) {
    return { kind: uriMatch[1].toLowerCase() as SpotifyKind, id: uriMatch[2] };
  }

  const urlMatch = raw.match(SPOTIFY_URL_RE);
  if (urlMatch) {
    return { kind: urlMatch[1].toLowerCase() as SpotifyKind, id: urlMatch[2] };
  }

  return null;
};

export const getSpotifyCanonicalUrl = (spotifyUrl: string): string | null => {
  const parsed = parseSpotifyResource(spotifyUrl);
  if (!parsed) return null;
  return `https://open.spotify.com/${parsed.kind}/${parsed.id}`;
};

export const getSpotifyEmbedUrl = (spotifyUrl: string): string | null => {
  const parsed = parseSpotifyResource(spotifyUrl);
  if (!parsed) return null;
  return `https://open.spotify.com/embed/${parsed.kind}/${parsed.id}?utm_source=generator&theme=0`;
};
